import { useDashboardChart } from "@/hooks/api/useDashboards";
import { HealthOutcomesView, type HealthOutcomesSource } from "./health-outcomes";
import type { Filters, OutcomeOptions, OutcomeSnapshot } from "./health-outcomes-contract";

const liveSource: HealthOutcomesSource = {
  synthetic: false,
  useOptions: () => useDashboardChart<Record<string, never>, OutcomeOptions>("health-outcomes", "options", {}),
  useSnapshot: (filters: Filters, enabled: boolean) => useDashboardChart<Filters, OutcomeSnapshot>("health-outcomes", "snapshot", filters, { enabled }),
};
export function HealthOutcomesDashboard() { return <HealthOutcomesView source={liveSource} />; }
